import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { maAdminPristup } from "./pristupyPouzivatelov";

export default function RequireAuth({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (
    user?.onboarding?.vyzadujePrveHeslo &&
    location.pathname !== "/prve-spustenie"
  ) {
    return <Navigate to="/prve-spustenie" replace />;
  }

  if (
    !user?.onboarding?.vyzadujePrveHeslo &&
    location.pathname === "/prve-spustenie"
  ) {
    return <Navigate to="/app" replace />;
  }

  if (requireAdmin && !maAdminPristup(user)) {
    return <Navigate to="/app" replace />;
  }

  return children;
}